import SectionDecoration from './SectionDecoration';

export default SectionDecoration;
